<template>
    <div class="login-container">
      <div class="login-box">
        <h2 class="login-title">物品管理后台</h2>
        <el-form :model="loginForm" class="login-form" label-position="top">
          <el-form-item label="用户名">
            <el-input v-model="loginForm.username" placeholder="请输入用户名" @keyup.enter="handleLogin"></el-input>
          </el-form-item>
          <el-form-item label="密码">
            <el-input 
              v-model="loginForm.password" 
              :type="showPassword ? 'text' : 'password'" 
              placeholder="请输入密码" 
              @keyup.enter="handleLogin"
            >
              <template #suffix>
                <i 
                  class="el-icon-view password-icon" 
                  :style="{color: showPassword ? '#409EFF' : '#c0c4cc'}"
                  @click="togglePassword"
                ></i>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleLogin" class="login-button">登录</el-button>
          </el-form-item>
          <div v-if="errorMessage" class="error-message">{{ errorMessage }}</div>
        </el-form>
      </div>
    </div>
  </template>
  
  <script>
  import axios from 'axios';
  
  export default {
    data() {
      return {
        loginForm: {
          username: '',
          password: '',
        },
        errorMessage: '',
        showPassword: false, // 新增显示密码状态
      };
    },
    methods: {

      togglePassword() {
        this.showPassword = !this.showPassword;
      },
      async handleLogin() {
        try {
          // 发送登录请求到后端
          const url = 'https://www.xinzhilian.top/product_flask/login'
          console.log('Request URL:', url);
          const response = await axios.post('https://www.xinzhilian.top/product_flask/login', {
            username: this.loginForm.username,
            password: this.loginForm.password,
          });
          // console.log('登录成功，response:', response);
  
          // 登录成功，获取 JWT token
          const token = response.data.token;
          const databaseName = response.data.database_name;
          const imageSpaceSize = response.data.image_space_size; // 获取图片空间大小
          // console.log('登录成功，Token:', token,databaseName);
  
          // 将 JWT 存储在本地存储中
          localStorage.setItem('jwt_token', token);
          localStorage.setItem('database_name', databaseName);
          localStorage.setItem('image_space_size', imageSpaceSize);
          // 跳转到管理页面
          this.$router.push('/admin'); // 假设管理页面路径为 /admin
        } catch (error) {
          // 处理登录失败的情况
          if (error.response && error.response.status === 404) {
            this.errorMessage = '用户名或密码错误';
          } else if (error.response && error.response.status === 402) {
              this.errorMessage = '账号已被封禁';
          } else if (error.response && error.response.status === 403) {
              this.errorMessage = '账号已过期';
          } else {
             this.errorMessage = '登录失败，请稍后再试';
           }
        }
      },
    },
  };
  </script>
  
  <style scoped>
  .login-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    background-color: #3a4e73;
  }
  .login-box {
    width: 350px;
    padding: 30px;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    background-color: #ffffff;
    text-align: center;
  }
  .login-title {
    font-size: 24px;
    color: #3a4e73;
    margin-bottom: 20px;
  }
  .login-form {
    width: 100%;
  }
  .login-button {
    width: 100%;
  }
  .error-message {
    color: red;
    margin-top: 10px;
  }

  .password-icon {
    cursor: pointer;
    padding: 0 5px;
    transition: color 0.3s;
  }

  .password-icon:hover {
    color: #409EFF !important;
  }
  </style>
  